import Pusher from "pusher-js"
import API from "@/interface/bleachServiceLayer"
import localPartyData from "../localtest/localPartyData"

export default {
  namespaced: true,

  state: {
    partyLink: "",
    buuid: "",
    activeParty: null,
    allParties: [],
    boundChannels: {},
    streamIsPlaying: false
  },
  mutations: {
    setActivePartyFromResponse(state, payload) {
      state.activeParty = Object.assign({}, payload)
    },
    setAllParties(state, payload) {
      state.allParties = Object.assign({}, payload)
    },
    setActivePartyState(state, payload) {
      state.activeParty.state = payload
    },
    setPartyLink(state, payload) {
      state.partyLink = payload
    },
    setBuuid(state, payload) {
      state.buuid = payload
    },
    addBoundChannel(state, payload) {
      state.boundChannels[payload] = true
    },
    setStreamIsPlaying(state, val) {
      state.streamIsPlaying = val
    }
  },
  actions: {
    getPartyFromLocalData({ commit, dispatch }, partyLink) {
      commit("setPartyLink", partyLink)
      commit("setActivePartyFromResponse", localPartyData)
      dispatch("chatStore/init", localPartyData.party_id, { root: true })
    },

    async getPartyFromLink({ state, commit, dispatch }, partyLink) {
      let existingBuuid = localStorage.getItem("bleach__buuid")
      if (existingBuuid != undefined) {
        commit("setBuuid", existingBuuid)
      }

      commit("setPartyLink", partyLink)

      const { buuid, partyId } = await API.getPartyId(partyLink, existingBuuid)

      if (buuid !== state.buuid) commit("setBuuid", buuid)

      window.snowplow("setUserId", buuid)

      API.getPartyDetails(partyId, buuid).then(partyState => {
        dispatch("setPusher", partyState.pusher)
        commit("setActivePartyFromResponse", partyState)
        dispatch("chatStore/init", partyState.party_id, { root: true })
      })
    },
    setupStream({ commit, state, dispatch }) {
      const { live_stream } = state.activeParty
      if (live_stream == undefined || live_stream.length == 0) {
        API.getPartyDetails(state.activeParty.party_id, state.buuid).then(
          partyState => {
            commit("setActivePartyFromResponse", partyState)
            dispatch("chatStore/init", partyState.party_id, { root: true })
          }
        )
      }
    },
    setPusher({ commit, dispatch, state }, { cluster, channel_id }) {
      if (state.boundChannels[channel_id] != undefined) {
        return
      }

      const pusher = new Pusher(process.env.VUE_APP_PUSHER_KEY, {
        cluster
      })
      const channel = pusher.subscribe(channel_id)

      channel.bind("state-change", event => {
        if (event && event.state) {
          commit("setActivePartyState", event.state)

          if (event.state == "live") {
            dispatch("setupStream")
          }
        }
      })

      commit("addBoundChannel", channel_id)
    }
  },
  getters: {
    shoppableLinks: state => state.activeParty.shoppable_links,
    shouldShowShoppableLinks: state => state.activeParty.show_shoppable_links
  }
}
